import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonusTotalValue, bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section id="bonuses" className="w-full scroll-mt-16 bg-ivory py-10 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-17" data-mp="gxq7lr5hj8q2">
      <div className="mx-auto max-w-5xl px-6" data-id="element-18" data-mp="qt9w3shpz54s">
        <SectionHeading eyebrow="🎁 The abundance bonus bundle" eyebrowTone="lime" title={<span id="bonuses-heading" data-id="element-20" data-mp="zuhlfl29cvmq">
              7 strategic bonuses.{' '}
              <span className="text-lime-ink" data-id="element-21" data-mp="zsevf113v2i0">
                {bonusTotalValue} value — yours free.
              </span>
            </span>} lead="The volumes solve what to teach. These bonuses solve everything around it: the drill you need in ten seconds, the words that fix an error, and the plan you write in five minutes." data-id="element-19" data-mp="qsi2uoblhjho" />

        <ul className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-id="element-22" data-mp="1jji8t4thkxbz">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-shell shadow-soft" data-id="element-23" data-mp="3prwmixz3m9xe">
              {/* The cover art runs edge to edge — no padding, no letterboxing. */}
              <img src={bonus.image} alt={bonus.alt} className="aspect-square w-full object-cover" width={1024} height={1024} sizes="(max-width: 640px) 45vw, (max-width: 1024px) 30vw, 220px" loading="lazy" decoding="async" data-id="element-24" data-mp="7l8jrerityuw" />

              <div className="flex flex-1 flex-col p-3.5" data-id="element-25" data-mp="legc58nfeydn">
                <div className="flex items-start justify-between gap-2" data-id="element-26" data-mp="q9vo1v1vik7f">
                  <p className="font-sans text-xs font-semibold uppercase tracking-[0.14em] text-navy" data-id="element-27" data-mp="vb2u9podbbbz">
                    Bonus {bonus.number}
                  </p>
                  <span className="rounded-full bg-lime-soft px-2 py-0.5 font-display text-xs font-bold text-lime-ink" data-id="element-28" data-mp="al8nt0opa1fd">
                    {bonus.value}
                  </span>
                </div>

                <h3 className="mt-2 font-display text-[0.9rem] font-bold leading-snug text-ink" data-id="element-29" data-mp="kb1zs2sr8ik5">
                  {bonus.title}
                </h3>
                <p className="mt-auto pt-2 font-sans text-xs leading-relaxed text-stone" data-id="element-30" data-mp="fjjy1ciwqdy4">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}